import template from './facilities.jade';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      category: '@',
      categoryInfo: '=',
      ad: '=',
      form: '=',
    },
    controller() {},
    controllerAs: 'facilitiesCtrl',
    replace: true,
  };
};
